import { ApiDOMError } from '@swagger-api/apidom-error';
class ParseError extends ApiDOMError {}
export default ParseError;